import { useDeviceSize } from "@climate-science/component-library";
import { useTranslation } from "next-i18next";
import Image from "next/dist/client/image";
import { FC, useState } from "react";
import styles from "./Team.module.scss";

export type place = "gold" | "silver" | "bronze"

export type team = {
  icon: StaticImageData,
  expand: boolean,
  participants?: participant[]
}

type participant = {
  img: StaticImageData,
  name: string,
  info: string,
  quote?: string
}

interface TeamProps {
  team: team,
  title: string,
  subtitle: string,
  description: string
}

const Winner = ({
  img,
  name,
  info
}:{
  img: StaticImageData,
  name: string,
  info: string
}) => {
  const {t} = useTranslation("olympiad")

  return (
    <div className={styles.winner}>
      <figure>
        <Image
          src={img}
          alt={t(name)}
        />
      </figure>
      <div>
        <h4>{t(name)}</h4>
        <p>{t(info)}</p>
      </div>
    </div>
  )
}

const Quote = ({
  img,
  name,
  info,
  quote
}:{
  img: StaticImageData,
  name: string,
  info: string,
  quote: string
}) => (
  <article className={styles.quote}>
    <figure>
      <Image
        src={img}
        alt={name}
      />
    </figure>
    <div className={styles.text}>
      <h4 className={styles.name}>{name}</h4>
      <p className={styles.info}>{info}</p>
      <p className={styles.textQuote}>{quote}</p>
    </div>
  </article>
)

const Team: FC<TeamProps> = ({
  team,
  title,
  subtitle,
  description
}) => {
  const [onDisplay, setOnDisplay] = useState<boolean>(false);
  const {t} = useTranslation("olympiad")
  const { isMobile, isSmallMobile } = useDeviceSize()

  return (
    <div
      className={styles.team}
      onClick={ () => setOnDisplay(!onDisplay)}
    >
      <div className={
        !team.expand && ( isMobile || isSmallMobile )
          ? styles.place
          : styles.displayNever
      }>
        <h4>{title}</h4>
        <p><strong>{subtitle}</strong></p>
      </div>
      <div
        className={
          !team.expand
            ? styles.card
            : styles.cardClickable
        }
      > 
        <figure className={
          !team.expand
            ? styles.displayNone
            : undefined
        }>
          <Image
            src={team.icon}
            alt={title}
          />
        </figure>
        <article className={
          !team.expand
            ? styles.displayNone
            : undefined
        }>
          <h4>{title}</h4>
          <p><strong>{subtitle}</strong></p>
          <p>{description}</p>
        </article>
        {
          !team.expand && (
            <div className={styles.hover}>
              {
                team.participants?.map((participant, i) => (
                  <Winner key={i}
                    img={participant.img}
                    name={participant.name}
                    info={participant.info}
                  />
                ))
              }
            </div>
          )
        }
      </div>
      {
        team.expand && (
          <article className={
            onDisplay || ( isMobile || isSmallMobile )
              ? styles.winnersOnDisplay
              : styles.winners
          } >
            {
              team.participants?.map((participant, i) => (
                <Quote key={i}
                  img={participant.img}
                  name={t(participant.name)}
                  info={t(participant.info)}
                  quote={t(participant.quote || "")}
                />
              ))
            }
          </article>
        )
      }
    </div>
  );
}

export default Team